import { useStudentAppMediaQuery } from '~/@common/hooks/useMediaQuery'

import { useStudentLectureAssignments } from '../@hooks/useStudentLectureAssignments'
import { LECTURE_STATUS_FILTER, type LectureStatusFilter } from '../@service/Lecture.service'
import AssignedLectureTable from './AssignedLectureTable.widget'
import MobileLectureCardList from './MobileLectureCardList.widget'

type Props = {
  lectureStatusFilter: LectureStatusFilter
}

const AssignedLectureList = ({ lectureStatusFilter }: Props) => {
  const { isMobile } = useStudentAppMediaQuery()

  const status = lectureStatusFilter === LECTURE_STATUS_FILTER.ALL ? undefined : lectureStatusFilter
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isFetched } =
    useStudentLectureAssignments({
      status,
    })

  const assignments =
    data?.pages.flatMap((page) =>
      Array.isArray(page.content) ? page.content : page.content ? [page.content] : [],
    ) ?? []
  const isFiltered = lectureStatusFilter !== LECTURE_STATUS_FILTER.ALL
  const infiniteScrollProps = {
    onLoadMore: fetchNextPage,
    hasNextPage: hasNextPage ?? false,
    isFetchingNextPage,
  }

  if (isMobile) {
    return (
      <MobileLectureCardList
        assignments={assignments}
        isFetched={isFetched}
        isFiltered={isFiltered}
        {...infiniteScrollProps}
      />
    )
  }

  return (
    <AssignedLectureTable
      assignments={assignments}
      isFetched={isFetched}
      isFiltered={isFiltered}
      {...infiniteScrollProps}
    />
  )
}

export default AssignedLectureList
